import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Observable";
import {ConciliacionData} from "./conciliacion-data";
import {HttpClient, HttpParams} from "@angular/common/http";
import {UrlsResources} from "../urls-resources";
import {ConciliacionDataRequest} from "./conciliacion-data-request";
import {ConciliacionCsvRequest} from "./conciliacion-csv-request";
import { HandleError } from '../handle-error';

@Injectable()
export class ConciliacionService {
  constructor(protected httpClient: HttpClient,
              private handleError: HandleError,
              protected urlsResources: UrlsResources) {
  }


  getDataFor(conciliacionDataRequest: ConciliacionDataRequest): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('games', conciliacionDataRequest.games.toString());
    params = params.set('date', conciliacionDataRequest.date);
    params = params.set('page', conciliacionDataRequest.page.toString());
    params = params.set('pageSize', conciliacionDataRequest.pageSize.toString());
    const options = {params: params, withCredentials: true};
    const conciliacionUrl = this.urlsResources.getConciliacionUrl();
    return this.httpClient.get(conciliacionUrl, options).catch(error => this.handleError.handleErrorAsObservable(error));
  }

  getDashboardDataPerGame(date: string): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('date', date);
    const options = {params: params, withCredentials: true};
    const conciliacionDashboardUrl = this.urlsResources.getConciliacionDashboardGamesUrl();
    return this.httpClient.get(conciliacionDashboardUrl, options).catch(error => this.handleError.handleErrorAsObservable(error));

  }

  getDashboardData(fechaInicial: string, fechaFinal: string): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('fechaInicial', fechaInicial);
    params = params.append('fechaFinal', fechaFinal);
    const options = {params: params, withCredentials: true};
    const conciliacionDashboardUrl = this.urlsResources.getConciliacionDashboardUrl();
    return this.httpClient.get(conciliacionDashboardUrl, options).catch(error => this.handleError.handleErrorAsObservable(error));
  }

  getDashboardErrorData(fechaInicial: string, fechaFinal: string): Observable<any> {
    let params: HttpParams =
      new HttpParams()
        .set('fechaInicial', fechaInicial)
        .set('fechaFinal', fechaFinal);

    const options = { params: params, withCredentials: true };
    const conciliacionDashboardUrl = this.urlsResources.getConciliacionErrorDashboardUrl();
    return this.httpClient.get(conciliacionDashboardUrl, options).catch(error => this.handleError.handleErrorAsObservable(error));
  }

  getDashboarCancelacionesdData(fechaInicial: string, fechaFinal: string): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('fechaInicial', fechaInicial);
    params = params.append('fechaFinal', fechaFinal);
    const options = {params: params, withCredentials: true};
    const conciliacionDashboardUrl = this.urlsResources.getConciliacionCancelacionDashboardUrl();
    return this.httpClient.get(conciliacionDashboardUrl, options).catch(error => this.handleError.handleErrorAsObservable(error));
  }

  downloadCsv(conciliacionCsvRequest: ConciliacionCsvRequest): Observable<any> {
    let params: HttpParams = new HttpParams();
    params = params.set('games', conciliacionCsvRequest.games.toString());
    params = params.set('date', conciliacionCsvRequest.date);
    const options = {params: params, withCredentials: true, responseType: 'blob' as 'blob'};
    const conciliacionCsvUrl = this.urlsResources.getConciliacionCsvUrl();
    return this.httpClient.get(conciliacionCsvUrl, options).catch(error => this.handleError.handleErrorAsObservable(error));
  }

  downloadTransactionReport(startDate: string, endDate: string): Observable<Blob> {
    const params: HttpParams = new HttpParams()
      .set('startDate', startDate)
      .set('endDate', endDate);
    const options = {params: params, withCredentials: true, responseType: 'blob' as 'blob'};
    const blnkTransactionReportUrl = this.urlsResources.getBlnkTransactionReportUrl();
    return this.httpClient.get(blnkTransactionReportUrl, options).catch(error => this.handleError.handleErrorAsObservable(error));
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/conciliacion/conciliacion.service.ts